import { Content } from '../../common/helpers/data/landingPages/fetchPostsData';
import logger from '../../common/helpers/logger/logger';
import { HeroVideoInfo } from '../../queries/homePage/heroVideo';

export function extractPostIds(
  moduleData: Content[],
  heroVideoData?: HeroVideoInfo,
): number[] {
  const result = new Set<number>();
  for (const item of moduleData) {
    if (item.type === 'post') {
      result.add(item.content.id);
    }
  }

  if (heroVideoData) {
    result.add(heroVideoData.id);
  }

  logger.logInfo(
    'extractPostIds',
    `Extracted Post Ids: ${JSON.stringify(Array.from(result))}`,
  );
  return Array.from(result);
}
